export default __webpack_public_path__ + "static/media/corona-safety.2cc80e1b.png";